import ApiService from "@/services";
import { handleApiError } from "../helpers";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async processPayment(_, payload) {
    try {
      const { data } = await ApiService.post(`payment/process`, payload);
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
